import React, { useEffect, useState } from "react";
import "../lastProjects/LastProjects.css";
import { UilAngleLeftB, UilAngleRightB } from "@iconscout/react-unicons";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";

const LastReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedReviewId, setSelectedReviewId] = useState(null);
  const [loading, setLoading] = useState(true);
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  // Stored lang is usually a plain string ("ar"/"en") but may be JSON-stringified.
  const [lang] = useState(() => {
    const raw = localStorage.getItem("lang");
    if (!raw) return "ar";
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === "string" ? parsed : "ar";
    } catch {
      return raw;
    }
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/dashboard/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/reviews?page=${currentPage}`);
        setReviews(response?.data?.reviews);
        setTotalPages(response?.data?.totalPages);
        setTotalReviews(response?.data?.totalReviews);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [currentPage]);

  const handleDeleteConfirm = (reviewId) => {
    setSelectedReviewId(reviewId);
    setShowConfirmation(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`/reviews/${selectedReviewId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReviews(reviews.filter((review) => review._id !== selectedReviewId));
      toast.success("Review has been deleted..!");
      setShowConfirmation(false);
      setSelectedReviewId(null);
    } catch (error) {
      console.error("Error deleting review:", error);
      toast.error(
        error.response.data.message || "An error occurred while deleting."
      );
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <BeatLoader />
      </div>
    );
  }

  return (
    <>
      <header className="lastProjectsHeader"></header>
      <main className="lastProjects">
        <div className="container">
          <div className="title">
            <h1>{`Last Reviews (${totalReviews})`}</h1>
          </div>
          <div className="table-container">
            <div className="table">
              <div className="head">
                <div className="col">
                  <div>ID</div>
                  <div>Title</div>
                  <div>Name</div>
                  <div>Created At</div>
                  <div>Actions</div>
                </div>
              </div>
              <div className="body">
                {reviews.map((review, index) => {
                  return (
                    <>
                      <div className="col">
                        <div>#{index + 1}</div>
                        <div>{review?.title}</div>
                        <div>{review?.name}</div>
                        <div>
                          {new Date(review.createdAt).getDate()}/
                          {new Date(review.createdAt).getMonth() + 1}/
                          {new Date(review.createdAt).getFullYear()}
                        </div>
                        <div className="actionIcons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                            className="delete"
                            onClick={() => handleDeleteConfirm(review?._id)}
                          >
                            <path
                              d="M27.1667 12.4862L24.5067 27.6142C24.3981 28.232 24.0753 28.7918 23.5949 29.1951C23.1145 29.5985 22.5073 29.8195 21.88 29.8195H11.12C10.4927 29.8195 9.88551 29.5985 9.4051 29.1951C8.92469 28.7918 8.60185 28.232 8.49333 27.6142L5.83333 12.4862M28.5 8.48617H21M21 8.48617V5.8195C21 5.11225 20.719 4.43398 20.219 3.93388C19.7189 3.43378 19.0406 3.15283 18.3333 3.15283H14.6667C13.9594 3.15283 13.2811 3.43378 12.781 3.93388C12.281 4.43398 12 5.11225 12 5.8195V8.48617M21 8.48617H12M4.5 8.48617H12"
                              stroke="#FE6565"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <Link to={`/dashboard/edit-review/${review?._id}`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="33"
                              height="33"
                              viewBox="0 0 33 33"
                              fill="none"
                            >
                              <path
                                d="M27.061 13.3396L28.297 12.1036C29.2803 11.1204 29.8327 9.7868 29.8327 8.39628C29.8327 7.00576 29.2803 5.67219 28.297 4.68895C27.3138 3.7057 25.9802 3.15332 24.5897 3.15332C23.1992 3.15332 21.8656 3.7057 20.8824 4.68895L19.6464 5.92495L8.2837 17.2849C7.51437 18.0556 7.12903 18.4409 6.79837 18.8649C6.40822 19.3656 6.07339 19.907 5.7997 20.4796C5.56903 20.9649 5.39703 21.4823 5.05303 22.5143L3.59437 26.8889M27.061 13.3396C27.061 13.3396 24.4357 13.1849 22.1184 10.8676C19.801 8.55161 19.6477 5.92495 19.6477 5.92495M27.061 13.3396L15.6997 24.6996C14.9304 25.4689 14.545 25.8543 14.121 26.1849C13.6204 26.5751 13.079 26.9099 12.5064 27.1836C12.021 27.4143 11.505 27.5863 10.4717 27.9303L6.09703 29.3889M6.09703 29.3889L5.0277 29.7463C4.77844 29.8299 4.5108 29.8423 4.25488 29.7821C3.99896 29.7219 3.76489 29.5916 3.579 29.4057C3.3931 29.2198 3.26273 28.9857 3.20256 28.7298C3.14238 28.4738 3.15478 28.2062 3.23837 27.957L3.5957 26.8876L6.09703 29.3889Z"
                                stroke="#15DC68"
                                stroke-width="1.5"
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                      {showConfirmation && (
                        <div className="confirmation-modal">
                          <div className="modal-content sec">
                            <img src="/photos/question.svg" alt="?" />
                            <p>Are you sure you want to delete this review?</p>
                            <div className="modal-actions">
                              <button onClick={handleDelete}>Yes</button>
                              <button
                                onClick={() => setShowConfirmation(false)}
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
              <div className="pagination" dir="ltr">
                {currentPage >= 1 && (
                  <div
                    onClick={() => handlePageChange(currentPage - 1)}
                    className="active"
                  >
                    {lang === "en" ? (
                      <UilAngleRightB size={32} color="white" />
                    ) : (
                      <UilAngleLeftB size={32} color="white" />
                    )}
                  </div>
                )}

                {Array.from({ length: totalPages }, (_, index) => index + 1)
                  .filter((pageNumber) => {
                    if (pageNumber === 1 || pageNumber === totalPages)
                      return true;
                    if (
                      pageNumber >= currentPage - 1 &&
                      pageNumber <= currentPage + 1
                    ) {
                      return true;
                    }
                    return false;
                  })
                  .map((pageNumber, index, filteredPages) => (
                    <>
                      {index > 0 &&
                        pageNumber !== filteredPages[index - 1] + 1 && (
                          <span className="dots">...</span>
                        )}
                      <div
                        key={pageNumber}
                        onClick={() => handlePageChange(pageNumber)}
                        className={currentPage === pageNumber ? "active" : ""}
                      >
                        {pageNumber}
                      </div>
                    </>
                  ))}

                {currentPage < totalPages && (
                  <div
                    onClick={() => handlePageChange(currentPage + 1)}
                    className="active"
                  >
                    {lang === "ar" ? (
                      <UilAngleRightB size={32} color="white" />
                    ) : (
                      <UilAngleLeftB size={32} color="white" />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default LastReviews;
